<template>
  <div>
    <LegacyMobileDialog v-if="mode !== 'waiting'" :title="mode === 'open' ? 'Posición abierta' : 'Añadir a cartera'" :subtitle="stock.ticker + ' · ' + (stock.nom || '')" :busy="saving" @close="close">
          <div v-if="waitingNames.length || openNames.length" class="legacy-portfolio-membership">
            <p v-if="waitingNames.length"><strong>En espera:</strong> {{ waitingNames.join(', ') }}</p>
            <p v-if="openNames.length"><strong>Posición abierta:</strong> {{ openNames.join(', ') }}</p>
            <small>Puedes añadirlo a otra cartera o registrar otra posición.</small>
          </div>
          <p v-else class="legacy-portfolio-hint">Este valor no figura en tus carteras.</p>
          <template v-if="mode === 'choose'">
            <button class="legacy-portfolio-choice" type="button" @click="mode = 'waiting'"><span class="material-icons-outlined" aria-hidden="true">schedule</span><span><strong>En espera</strong><small>Seguir el valor antes de comprar.</small></span><span aria-hidden="true">›</span></button>
            <button class="legacy-portfolio-choice" type="button" @click="openPosition"><span class="material-icons-outlined" aria-hidden="true">account_balance_wallet</span><span><strong>Posición abierta</strong><small>Registrar una compra ya realizada.</small></span><span aria-hidden="true">›</span></button>
          </template>
          <template v-else>
            <p class="legacy-portfolio-hint">Registra los datos reales de la operación. No se envía ninguna orden al bróker.</p>
            <label class="legacy-portfolio-select">Cartera<select v-model="selectedPortfolio" :disabled="saving"><option disabled value="">Selecciona una cartera</option><option v-for="portfolio in portfolios" :key="portfolio.name" :value="String(portfolio.name)">{{ portfolio.value }}</option></select></label>
            <p v-if="!portfolios.length" role="status">No hay carteras disponibles. Crea una desde Carteras.</p>
            <OpenPositionImportForm v-if="selectedPortfolio" ref="positionForm" :portfolio-id="selectedPortfolio" :is-submitting="saving" :error="error" @error="error = $event" @submit="savePosition" />
          </template>
        <template v-if="mode === 'open'" #footer><button type="button" :disabled="saving" @click="mode = 'choose'; error = null">Volver</button><button class="primary" type="button" :disabled="saving || !selectedPortfolio" @click="$refs.positionForm.submitForm()">{{ saving ? 'Guardando…' : 'Guardar posición' }}</button></template>
    </LegacyMobileDialog>
    <WaitingValuesMobile v-else :stock="stock" :stocks="stocks" :show_waiting="true" back-label="Volver" @waiting-added="saved" @back="mode = 'choose'" @_closeWaitingValueWindow="close" />
  </div>
</template>
<script>
import OpenPositionImportForm from '@/features/portfolio/current/OpenPositionImportForm.vue';
import apiService from '@/features/portfolio/current/apiService';
import WaitingValuesMobile from './WaitingValuesMobile.vue';
import LegacyMobileDialog from './LegacyMobileDialog.vue';
export default {
  components: { OpenPositionImportForm, WaitingValuesMobile, LegacyMobileDialog },
  props: { stock: { type: Object, required: true }, stocks: { type: Array, default: () => [] }, portfolios: { type: Array, default: () => [] }, portfolioId: { type: String, default: '' } },
  data() { return { mode: 'choose', selectedPortfolio: this.portfolioId, saving: false, error: null, returnFocus: null }; },
  computed: {
    waitingNames() { return this.names(this.stock.waitings_portfolio_name); },
    openNames() { return this.names(this.stock.open_positions_portfolio_name); }
  },
  methods: {
    names(value) { return (Array.isArray(value) ? value : value ? [value] : []).filter(Boolean); },
    close() { if (!this.saving) this.$emit('close'); },
    saved() { this.$emit('saved'); this.$emit('close'); },
    async openPosition() {
      this.mode = 'open';
      if (!this.selectedPortfolio && this.portfolios.length) this.selectedPortfolio = String(this.portfolios[0].name);
      await this.$nextTick();
      if (this.$refs.positionForm) this.$refs.positionForm.selectTicker(this.stock.ticker);
    },
    async savePosition(data) {
      if (this.saving || !this.selectedPortfolio) return;
      this.saving = true; this.error = null;
      try {
        const result = await apiService.importOpenPosition(this.selectedPortfolio, data);
        if (result && (result.error || result.success === false || (result.status && !['ok', 'success'].includes(result.status)))) throw new Error('No se ha podido guardar la posición.');
        this.$emit('saved'); this.$emit('close');
      } catch (error) { this.error = error.message || 'No se ha podido guardar la posición.'; }
      finally { this.saving = false; }
    },
    trapFocus(event) {
      const nodes = [...this.$refs.dialog.querySelectorAll('button:not(:disabled), select:not(:disabled), input:not(:disabled):not([type="hidden"]), [tabindex="0"]')].filter(node => node.getClientRects().length);
      const first = nodes[0], last = nodes[nodes.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === this.$refs.dialog)) { event.preventDefault(); if (last) last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); if (first) first.focus(); }
    }
  }
};
</script>
<style scoped>
.legacy-portfolio-membership { padding: 10px; margin-bottom: 16px; background: #00add910; border: 1px solid #00add940; border-radius: 6px; }
.legacy-portfolio-membership p { font-size: 13px; margin: 0 0 6px; }
.legacy-portfolio-hint, small { font-size: 12px; line-height: 1.5; }
.legacy-portfolio-choice { display: flex; align-items: center; gap: 12px; text-align: left; padding: 14px 10px; margin-top: 10px; width: 100%; }
.legacy-portfolio-choice > span:nth-child(2) { flex: 1; }.legacy-portfolio-choice strong, .legacy-portfolio-choice small { display: block; }
.legacy-portfolio-select { display: block; font-size: 13px; margin: 12px 0; }
</style>
